<template>
    <div v-if="widget" class="wb-widget">
        <transition name="wb-visible">
            <div class="wb-widget__dialog" v-show="visible">
                <perfect-scrollbar :options="{suppressScrollX: true}">
                    <div class="wb-widget__dialog-scroll">
                        <template v-if="widget.banner && widget.banner.url">
                            <a v-if="widget.banner_url"
                               class="wb-widget__banner"
                               :href="widget.banner_url"
                               rel="nofollow"
                               target="_blank">
                                <img :src="widget.banner.url">
                            </a>
                            <div v-else class="wb-widget__banner">
                                <img :src="widget.banner.url">
                            </div>
                        </template>
                        <div class="wb-widget__header" :class="{'wb-widget__header_s': action === 'qr-code'}">
                            <template v-if="action === 'list'">
                                <div class="wb-widget__title" v-if="widget.title">
                                    {{ widget.title }}
                                    <div class="wb-widget__close" @click="visible = false">
                                        <svg xmlns="http://www.w3.org/2000/svg" height="32px" viewBox="0 0 24 24" width="32px" fill="#333">
                                            <path d="M0 0h24v24H0V0z" fill="none"/>
                                            <path d="M18.3 5.71c-.39-.39-1.02-.39-1.41 0L12 10.59 7.11 5.7c-.39-.39-1.02-.39-1.41 0-.39.39-.39 1.02 0 1.41L10.59 12 5.7 16.89c-.39.39-.39 1.02 0 1.41.39.39 1.02.39 1.41 0L12 13.41l4.89 4.89c.39.39 1.02.39 1.41 0 .39-.39.39-1.02 0-1.41L13.41 12l4.89-4.89c.38-.38.38-1.02 0-1.4z"/>
                                        </svg>
                                    </div>
                                </div>
                                <div class="wb-widget__description" v-if="widget.description">{{ widget.description }}</div>
                            </template>
                            <template v-if="action === 'qr-code'">
                                <div class="wb-widget__title" v-if="qrCodeView.title">{{ qrCodeView.title }}</div>
                            </template>
                        </div>
                        <div class="wb-widget__content">
                            <template v-if="action === 'list'">
                                <div class="wb-widget__links" v-if="!isDesktop">
                                    <perfect-scrollbar :options="{suppressScrollX: true}">
                                        <div class="wb-widget__scroll">
                                            <a class="wb-widget__link"
                                               v-for="(link, index) in widget.links"
                                               :href="link.data.url"
                                               target="_blank"
                                               :key="index">
                                                <ChannelIcon :type="getLinkType(link)"></ChannelIcon>
                                                {{ getName(link) }}
                                            </a>
                                        </div>
                                    </perfect-scrollbar>
                                </div>
                                <div class="wb-widget__links" v-else>
                                    <perfect-scrollbar :options="{suppressScrollX: true}">
                                        <div class="wb-widget__scroll">
                                            <template v-for="(link, index) in widget.links">
                                                <div class="wb-widget__link"
                                                     :key="index"
                                                     v-if="getLinkType(link) !== 'link'"
                                                     @click="showQRCode(link)">
                                                    <ChannelIcon :type="getLinkType(link)"></ChannelIcon>
                                                    {{ getName(link) }}
                                                </div>
                                                <a class="wb-widget__link"
                                                   v-else
                                                   :key="index"
                                                   :href="link.data.url"
                                                   target="_blank">
                                                    <ChannelIcon :type="link.type"></ChannelIcon>
                                                    {{ getName(link) }}
                                                </a>
                                            </template>
                                        </div>
                                    </perfect-scrollbar>
                                </div>
                            </template>
                            <template v-if="action === 'qr-code'">
                                <div class="wb-widget__channel">
                                    <template v-if="qrCodeView.url">
                                        <div class="wb-widget__channel-info" v-if="qrCodeView.info">{{ qrCodeView.info }}</div>
                                        <div class="wb-widget__channel-qr-code">
                                            <QqCode
                                                :text="qrCodeView.url"
                                                bgColor="#ffffff"
                                                color="#2b2f35">
                                            </QqCode>
                                        </div>
                                        <a :href="qrCodeView.url"
                                           target="_blank"
                                           class="wb-widget__channel-btn"
                                           :class="[`wb-widget__channel-btn_${qrCodeView.type}`]">
                                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" v-if="qrCodeView.type === 'telegram'"><path fill="#ffffff" d="M24 4A20 20 0 1 0 24 44A20 20 0 1 0 24 4Z"/><path fill="#32afed" d="M33.95,15l-3.746,19.126c0,0-0.161,0.874-1.245,0.874c-0.576,0-0.873-0.274-0.873-0.274l-8.114-6.733 l-3.97-2.001l-5.095-1.355c0,0-0.907-0.262-0.907-1.012c0-0.625,0.933-0.923,0.933-0.923l21.316-8.468 c-0.001-0.001,0.651-0.235,1.126-0.234C33.667,14,34,14.125,34,14.5C34,14.75,33.95,15,33.95,15z"/><path fill="#b0bec5" d="M23,30.505l-3.426,3.374c0,0-0.149,0.115-0.348,0.12c-0.069,0.002-0.143-0.009-0.219-0.043 l0.964-5.965L23,30.505z"/><path fill="#cfd8dc" d="M29.897,18.196c-0.169-0.22-0.481-0.26-0.701-0.093L16,26c0,0,2.106,5.892,2.427,6.912 c0.322,1.021,0.58,1.045,0.58,1.045l0.964-5.965l9.832-9.096C30.023,18.729,30.064,18.416,29.897,18.196z"/></svg>
                                            <svg xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 48 48" v-else-if="qrCodeView.type === 'whatsapp'" fill-rule="evenodd" clip-rule="evenodd"><path fill="#fff" d="M4.868,43.303l2.694-9.835C5.9,30.59,5.026,27.324,5.027,23.979C5.032,13.514,13.548,5,24.014,5c5.079,0.002,9.845,1.979,13.43,5.566c3.584,3.588,5.558,8.356,5.556,13.428c-0.004,10.465-8.522,18.98-18.986,18.98c-0.001,0,0,0,0,0h-0.008c-3.177-0.001-6.3-0.798-9.073-2.311L4.868,43.303z"/><path fill="#fff" d="M4.868,43.803c-0.132,0-0.26-0.052-0.355-0.148c-0.125-0.127-0.174-0.312-0.127-0.483l2.639-9.636c-1.636-2.906-2.499-6.206-2.497-9.556C4.532,13.238,13.273,4.5,24.014,4.5c5.21,0.002,10.105,2.031,13.784,5.713c3.679,3.683,5.704,8.577,5.702,13.781c-0.004,10.741-8.746,19.48-19.486,19.48c-3.189-0.001-6.344-0.788-9.144-2.277l-9.875,2.589C4.953,43.798,4.911,43.803,4.868,43.803z"/><path fill="#01e675" d="M24.014,5c5.079,0.002,9.845,1.979,13.43,5.566c3.584,3.588,5.558,8.356,5.556,13.428c-0.004,10.465-8.522,18.98-18.986,18.98h-0.008c-3.177-0.001-6.3-0.798-9.073-2.311L4.868,43.303l2.694-9.835C5.9,30.59,5.026,27.324,5.027,23.979C5.032,13.514,13.548,5,24.014,5 M24.014,42.974C24.014,42.974,24.014,42.974,24.014,42.974C24.014,42.974,24.014,42.974,24.014,42.974 M24.014,42.974C24.014,42.974,24.014,42.974,24.014,42.974C24.014,42.974,24.014,42.974,24.014,42.974 M24.014,4C24.014,4,24.014,4,24.014,4C12.998,4,4.032,12.962,4.027,23.979c-0.001,3.367,0.849,6.685,2.461,9.622l-2.585,9.439c-0.094,0.345,0.002,0.713,0.254,0.967c0.19,0.192,0.447,0.297,0.711,0.297c0.085,0,0.17-0.011,0.254-0.033l9.687-2.54c2.828,1.468,5.998,2.243,9.197,2.244c11.024,0,19.99-8.963,19.995-19.98c0.002-5.339-2.075-10.359-5.848-14.135C34.378,6.083,29.357,4.002,24.014,4L24.014,4z"/><path fill="#01e675" d="M35.176,12.832c-2.98-2.982-6.941-4.625-11.157-4.626c-8.704,0-15.783,7.076-15.787,15.774c-0.001,2.981,0.833,5.883,2.413,8.396l0.376,0.597l-1.595,5.821l5.973-1.566l0.577,0.342c2.422,1.438,5.2,2.198,8.032,2.199h0.006c8.698,0,15.777-7.077,15.78-15.776C39.795,19.778,38.156,15.814,35.176,12.832z"/><path fill="#fff" fill-rule="evenodd" d="M19.268,16.045c-0.355-0.79-0.729-0.806-1.068-0.82c-0.277-0.012-0.593-0.011-0.909-0.011c-0.316,0-0.83,0.119-1.265,0.594c-0.435,0.475-1.661,1.622-1.661,3.956c0,2.334,1.7,4.59,1.937,4.906c0.237,0.316,3.282,5.259,8.104,7.161c4.007,1.58,4.823,1.266,5.693,1.187c0.87-0.079,2.807-1.147,3.202-2.255c0.395-1.108,0.395-2.057,0.277-2.255c-0.119-0.198-0.435-0.316-0.909-0.554s-2.807-1.385-3.242-1.543c-0.435-0.158-0.751-0.237-1.068,0.238c-0.316,0.474-1.225,1.543-1.502,1.859c-0.277,0.317-0.554,0.357-1.028,0.119c-0.474-0.238-2.002-0.738-3.815-2.354c-1.41-1.257-2.362-2.81-2.639-3.285c-0.277-0.474-0.03-0.731,0.208-0.968c0.213-0.213,0.474-0.554,0.712-0.831c0.237-0.277,0.316-0.475,0.474-0.791c0.158-0.317,0.079-0.594-0.04-0.831C20.612,19.329,19.69,16.983,19.268,16.045z" clip-rule="evenodd"/></svg>
                                            <svg xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 48 48" v-else-if="qrCodeView.type === 'viber'"><path fill="#8074d6" d="M24,5C21.361,5,13.33,5,8.89,9.054C6.246,11.688,5,15.494,5,21v3c0,5.506,1.246,9.312,3.921,11.976 c1.332,1.215,3.148,2.186,5.368,2.857L15,39.047v5.328C15,45,15.181,45,15.241,45c0.123,0,0.32-0.039,0.694-0.371 c0.09-0.089,0.75-0.803,3.96-4.399l0.324-0.363l0.485,0.031C21.779,39.965,22.888,40,24,40c2.639,0,10.67,0,15.11-4.055 C41.753,33.311,43,29.505,43,24v-3c0-5.506-1.246-9.312-3.921-11.976C34.67,5,26.639,5,24,5z"/><path fill="#fff" d="M33.451 28.854c-1.111-.936-1.624-1.219-3.158-2.14C29.654 26.331 28.68 26 28.169 26c-.349 0-.767.267-1.023.523C26.49 27.179 26.275 28 25.125 28c-1.125 0-3.09-1.145-4.5-2.625C19.145 23.965 18 22 18 20.875c0-1.15.806-1.38 1.462-2.037C19.718 18.583 20 18.165 20 17.816c0-.511-.331-1.47-.714-2.109-.921-1.535-1.203-2.048-2.14-3.158-.317-.376-.678-.548-1.056-.549-.639-.001-1.478.316-2.046.739-.854.637-1.747 1.504-1.986 2.584-.032.147-.051.295-.057.443-.046 1.125.396 2.267.873 3.234 1.123 2.279 2.609 4.485 4.226 6.455.517.63 1.08 1.216 1.663 1.782.566.582 1.152 1.145 1.782 1.663 1.97 1.617 4.176 3.103 6.455 4.226.958.472 2.086.906 3.2.874.159-.005.318-.023.477-.058 1.08-.238 1.947-1.132 2.584-1.986.423-.568.74-1.406.739-2.046C33.999 29.532 33.827 29.171 33.451 28.854zM34 24c-.552 0-1-.448-1-1v-1c0-4.962-4.038-9-9-9-.552 0-1-.448-1-1s.448-1 1-1c6.065 0 11 4.935 11 11v1C35 23.552 34.552 24 34 24zM27.858 22c-.444 0-.85-.298-.967-.748-.274-1.051-1.094-1.872-2.141-2.142-.535-.139-.856-.684-.718-1.219.138-.534.682-.855 1.219-.718 1.748.453 3.118 1.822 3.575 3.574.139.535-.181 1.08-.715 1.22C28.026 21.989 27.941 22 27.858 22z"/><path fill="#fff" d="M31,23c-0.552,0-1-0.448-1-1c0-3.188-2.494-5.818-5.678-5.986c-0.552-0.029-0.975-0.5-0.946-1.051 c0.029-0.552,0.508-0.976,1.051-0.946C28.674,14.241,32,17.748,32,22C32,22.552,31.552,23,31,23z"/><path fill="#fff" d="M24,4C19.5,4,12.488,4.414,8.216,8.316C5.196,11.323,4,15.541,4,21c0,0.452-0.002,0.956,0.002,1.5 C3.998,23.043,4,23.547,4,23.999c0,5.459,1.196,9.677,4.216,12.684c1.626,1.485,3.654,2.462,5.784,3.106v4.586 C14,45.971,15.049,46,15.241,46h0.009c0.494-0.002,0.921-0.244,1.349-0.624c0.161-0.143,2.02-2.215,4.042-4.481 C21.845,40.972,22.989,41,23.999,41c0,0,0,0,0,0s0,0,0,0c4.5,0,11.511-0.415,15.784-4.317c3.019-3.006,4.216-7.225,4.216-12.684 c0-0.452,0.002-0.956-0.002-1.5c0.004-0.544,0.002-1.047,0.002-1.5c0-5.459-1.196-9.677-4.216-12.684C35.511,4.414,28.5,4,24,4z M41,23.651l0,0.348c0,4.906-1.045,8.249-3.286,10.512C33.832,38,26.437,38,23.999,38c-0.742,0-1.946-0.001-3.367-0.1 C20.237,38.344,16,43.083,16,43.083V37.22c-2.104-0.505-4.183-1.333-5.714-2.708C8.045,32.248,7,28.905,7,23.999l0-0.348 c0-0.351-0.001-0.73,0.002-1.173C6.999,22.078,6.999,21.7,7,21.348L7,21c0-4.906,1.045-8.249,3.286-10.512 C14.167,6.999,21.563,6.999,24,6.999c2.437,0,9.832,0,13.713,3.489c2.242,2.263,3.286,5.606,3.286,10.512l0,0.348 c0,0.351,0.001,0.73-0.002,1.173C41,22.922,41,23.3,41,23.651z"/></svg>
                                            <svg xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 48 48" v-else-if="qrCodeView.type === 'vk'"><path fill="#ffffff" d="M24 4A20 20 0 1 0 24 44A20 20 0 1 0 24 4Z"/><path fill="#5181b8" d="M35.937,18.041c0.046-0.151,0.068-0.291,0.062-0.416C35.984,17.263,35.735,17,35.149,17h-2.618 c-0.661,0-0.966,0.4-1.144,0.801c0,0-1.632,3.359-3.513,5.574c-0.61,0.641-0.92,0.625-1.25,0.625C26.447,24,26,23.786,26,23.199 v-5.185C26,17.32,25.827,17,25.268,17h-4.649C20.212,17,20,17.32,20,17.641c0,0.667,0.898,0.827,1,2.696v3.623 C21,24.84,20.847,25,20.517,25c-0.89,0-2.642-3-3.815-6.932C16.448,17.294,16.194,17,15.533,17h-2.643 C12.127,17,12,17.374,12,17.774c0,0.721,0.6,4.619,3.875,9.101C18.25,30.125,21.379,32,24.149,32c1.678,0,1.85-0.427,1.85-1.094 v-2.972C26,27.133,26.183,27,26.717,27c0.381,0,1.158,0.25,2.658,2c1.73,2.018,2.044,3,3.036,3h2.618 c0.608,0,0.957-0.255,0.971-0.75c0.003-0.126-0.015-0.267-0.056-0.424c-0.194-0.576-1.084-1.984-2.194-3.326 c-0.615-0.743-1.222-1.479-1.501-1.879C32.062,25.36,31.991,25.176,32,25c0.009-0.185,0.105-0.361,0.249-0.607 C32.223,24.393,35.607,19.642,35.937,18.041z"/></svg>
                                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" v-else-if="qrCodeView.type === 'facebook'"><path fill="#ffffff" d="M24 5A19 19 0 1 0 24 43A19 19 0 1 0 24 5Z"/><path fill="#0084ff" d="M26.572,29.036h4.917l0.772-4.995h-5.69v-2.73c0-2.075,0.678-3.915,2.619-3.915h3.119v-4.359c-0.548-0.074-1.707-0.236-3.897-0.236c-4.573,0-7.254,2.415-7.254,7.917v3.323h-4.701v4.995h4.701v13.729C22.089,42.905,23.032,43,24,43c0.875,0,1.729-0.08,2.572-0.194V29.036z"/></svg>
                                            <svg xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 24 24" v-else-if="qrCodeView.type === 'instagram'"><path d="M 8 3 C 5.239 3 3 5.239 3 8 L 3 16 C 3 18.761 5.239 21 8 21 L 16 21 C 18.761 21 21 18.761 21 16 L 21 8 C 21 5.239 18.761 3 16 3 L 8 3 z M 18 5 C 18.552 5 19 5.448 19 6 C 19 6.552 18.552 7 18 7 C 17.448 7 17 6.552 17 6 C 17 5.448 17.448 5 18 5 z M 12 7 C 14.761 7 17 9.239 17 12 C 17 14.761 14.761 17 12 17 C 9.239 17 7 14.761 7 12 C 7 9.239 9.239 7 12 7 z M 12 9 A 3 3 0 0 0 9 12 A 3 3 0 0 0 12 15 A 3 3 0 0 0 15 12 A 3 3 0 0 0 12 9 z" fill="#ffffff"/></svg>
                                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" fill="none" v-else-if="qrCodeView.type === 'icq'"><rect width="512" height="512" rx="256" fill="#ffffff"/><path fill-rule="evenodd" clip-rule="evenodd" d="M270.539 198.672L291.778 155.878L291.688 155.884C295.783 147.496 297.803 137.959 297.125 127.983C295.058 97.5421 268.661 74.5439 238.166 76.615C207.671 78.6861 184.626 105.042 186.694 135.483C187.393 145.787 190.881 155.238 196.371 163.152L221.816 200.583C226.694 209.663 236.58 215.541 247.549 214.796C257.966 214.089 266.607 207.595 270.539 198.672Z" fill="#28ca86"/><path fill-rule="evenodd" clip-rule="evenodd" d="M312.702 258.404L365.506 266.237L365.464 266.132C375.863 267.596 386.77 266.44 397.209 262.247C429.071 249.448 444.506 213.197 431.685 181.278C418.863 149.36 382.64 133.86 350.777 146.659C339.823 151.06 330.81 158.232 324.22 167.048L291.874 208.517C291.498 208.971 291.136 209.436 290.787 209.91L290.644 210.094L290.657 210.089C284.727 218.29 283.009 229.272 287.065 239.369C291.496 250.4 301.635 257.426 312.702 258.404Z" fill="#28ca86"/><path fill-rule="evenodd" clip-rule="evenodd" d="M268.117 313.1L273.77 360.781L273.841 360.727C275.03 370.131 278.619 379.356 284.742 387.456C303.442 412.198 338.695 417.069 363.481 398.335C388.268 379.601 393.201 344.357 374.5 319.615C368.043 311.072 359.613 304.898 350.322 301.247L308.279 283.751C299.095 278.813 287.479 279.341 278.603 286.049C269.981 292.567 266.264 303.164 268.117 313.1Z" fill="#28ca86"/><path fill-rule="evenodd" clip-rule="evenodd" d="M198.437 286.022L151.449 310.547L151.533 310.6C142.303 315.505 134.197 322.817 128.244 332.301C110.074 361.251 118.854 399.476 147.855 417.679C176.857 435.882 215.097 427.169 233.268 398.219C239.474 388.331 242.536 377.361 242.723 366.477L244.3 316.051C245.832 304.628 240.742 292.821 230.329 286.285C220.268 279.971 207.936 280.27 198.437 286.022Z" fill="#28ca86"/><path fill-rule="evenodd" clip-rule="evenodd" d="M205.163 222.936L176.741 195.108L176.723 195.18C171.135 189.783 164.103 185.732 156.032 183.702C131.39 177.506 106.382 192.494 100.175 217.18C93.968 241.865 108.912 266.899 133.553 273.095C141.625 275.125 149.737 274.882 157.214 272.769L157.213 272.773L194.31 261.99C202.684 260.41 209.803 254.118 212.021 245.297C214.142 236.863 211.221 228.346 205.163 222.936Z" fill="#28ca86"/></svg>
                                            {{ qrCodeView.name }}
                                        </a>
                                    </template>
                                    <template v-else>{{ trans('linkNotSet') }}</template>
                                </div>
                            </template>
                        </div>
                        <a v-if="copyrightUrl && copyrightName"
                           class="wb-widget__copyright"
                           :href="`${copyrightUrl}?utm_source=widget`"
                           target="_blank">
                            Powered by <b>{{ copyrightName }}</b>
                        </a>
                    </div>
                </perfect-scrollbar>
            </div>
        </transition>
        <div class="wb-widget__icon">
            <div class="wb-widget__btn wb-widget__btn_cog" @click="$emit('clickSettings')" v-if="inline && visible">
                <div>
                    <svg xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 24 24" height="32px" viewBox="0 0 24 24" width="32px" fill="#ffffff">
                        <rect fill="none" height="24" width="24"/>
                        <path d="M19.5,12c0-0.23-0.01-0.45-0.03-0.68l1.86-1.41c0.4-0.3,0.51-0.86,0.26-1.3l-1.87-3.23c-0.25-0.44-0.79-0.62-1.25-0.42 l-2.15,0.91c-0.37-0.26-0.76-0.49-1.17-0.68l-0.29-2.31C14.8,2.38,14.37,2,13.87,2h-3.73C9.63,2,9.2,2.38,9.14,2.88L8.85,5.19 c-0.41,0.19-0.8,0.42-1.17,0.68L5.53,4.96c-0.46-0.2-1-0.02-1.25,0.42L2.41,8.62c-0.25,0.44-0.14,0.99,0.26,1.3l1.86,1.41 C4.51,11.55,4.5,11.77,4.5,12s0.01,0.45,0.03,0.68l-1.86,1.41c-0.4,0.3-0.51,0.86-0.26,1.3l1.87,3.23c0.25,0.44,0.79,0.62,1.25,0.42 l2.15-0.91c0.37,0.26,0.76,0.49,1.17,0.68l0.29,2.31C9.2,21.62,9.63,22,10.13,22h3.73c0.5,0,0.93-0.38,0.99-0.88l0.29-2.31 c0.41-0.19,0.8-0.42,1.17-0.68l2.15,0.91c0.46,0.2,1,0.02,1.25-0.42l1.87-3.23c0.25-0.44,0.14-0.99-0.26-1.3l-1.86-1.41 C19.49,12.45,19.5,12.23,19.5,12z M12.04,15.5c-1.93,0-3.5-1.57-3.5-3.5s1.57-3.5,3.5-3.5s3.5,1.57,3.5,3.5S13.97,15.5,12.04,15.5z"/>
                    </svg>
                </div>
            </div>
            <div class="wb-widget__btn" @click="visible = !visible" :style="{background: widget.style.button.background}">
                <transition name="wb-show-icon">
                    <div v-if="!visible">
                        <svg xmlns="http://www.w3.org/2000/svg" height="32px" viewBox="0 0 24 24" width="32px" :fill="widget.style.button.color">
                            <path d="M0 0h24v24H0V0z" fill="none"/>
                            <path d="M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM9 11H7V9h2v2zm4 0h-2V9h2v2zm4 0h-2V9h2v2z"/>
                        </svg>
                    </div>
                </transition>
                <transition name="wb-close-icon">
                    <div v-if="visible">
                        <svg xmlns="http://www.w3.org/2000/svg" height="42px" viewBox="0 0 24 24" width="42px" :fill="widget.style.button.color">
                            <path d="M0 0h24v24H0V0z" fill="none"/>
                            <path d="M18.3 5.71c-.39-.39-1.02-.39-1.41 0L12 10.59 7.11 5.7c-.39-.39-1.02-.39-1.41 0-.39.39-.39 1.02 0 1.41L10.59 12 5.7 16.89c-.39.39-.39 1.02 0 1.41.39.39 1.02.39 1.41 0L12 13.41l4.89 4.89c.39.39 1.02.39 1.41 0 .39-.39.39-1.02 0-1.41L13.41 12l4.89-4.89c.38-.38.38-1.02 0-1.4z"/>
                        </svg>
                    </div>
                </transition>
            </div>
        </div>
    </div>
</template>

<script>
import QqCode from 'vue-qrcode-component'
import { PerfectScrollbar } from 'vue2-perfect-scrollbar'

import WhatsAppIcon from "./icons/WhatsAppIcon"
import TelegramIcon from "./icons/TelegramIcon";
import ViberIcon from "./icons/ViberIcon"
import VKIcon from "./icons/VKIcon"
import LinkIcon from "./icons/LinkIcon"
import FacebookIcon from "./icons/FacebookIcon"
import InstagramIcon from "./icons/InstagramIcon"
import ICQIconIcon from "./icons/ICQIcon"
import ChannelIcon from "./icons/Icon"

import {trans} from "./i18n";

export default {
    components: {
        PerfectScrollbar,
        QqCode,
        TelegramIcon,
        WhatsAppIcon,
        ViberIcon,
        VKIcon,
        LinkIcon,
        FacebookIcon,
        InstagramIcon,
        ICQIconIcon,
        ChannelIcon,
    },
    props: {
        widgetData: Object,
        inline: Boolean,
        copyrightUrl: String,
        copyrightName: String,
        apiUrl: String,
    },
    data() {
        const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(window.navigator.userAgent)

        let lang = document.getElementsByTagName("html")[0].getAttribute("lang")
        if (!lang) {
            lang = window.navigator.language
        }

        return {
            visible: false,
            isDesktop: !isMobile,
            action: 'list',
            widget: null,
            lang: lang.substr(0, 2),
            qrCodeView: {
                title: null,
                info: null,
                url: null,
                name: null,
                type: null,
            }
        }
    },
    watch: {
        visible(v) {
            if (!v) {
                this.action = 'list'
            }
        }
    },
    methods: {
        getName(link) {
            switch (link.type) {
                case "link":
                    return link.data.name ? link.data.name : this.trans('link')
                case "whatsapp":
                    return "WhatsApp"
                case "telegram":
                    return "Telegram"
                case "viber":
                    return "Viber"
                case "vk":
                    return "VK"
                case "facebook":
                    return "Facebook"
                case "instagram":
                    return "Instagram"
                case "icq":
                    return "ICQ"
                default:
                    return link.type
            }
        },
        showQRCode(link) {
            const backup = link.type
            link.type = this.getLinkType(link)
            const channelName = this.getName(link)
            link.type = backup

            this.qrCodeView = {
                title: this.getName(link),
                info: this.trans('scanQrCode', {name: channelName}),
                url: link.data.url,
                name: this.trans('openChannel', {name: channelName}),
                type: this.getLinkType(link),
            }
            this.action = 'qr-code'
        },

        load() {
            if (!this.widgetData) {
                axios.get(this.apiUrl)
                    .then(r => {
                        this.widget = r.data.data
                        if (this.inline) {
                            this.visible = true
                        }
                    })
                    .catch(e => {
                        console.log("Widget loading failed")
                        console.log(e)
                    })
            } else {
                this.widget = this.widgetData
                if (this.inline) {
                    this.visible = true
                }
            }
        },
        trans(key, replacement) {
            return trans(this.lang, key, replacement)
        },
        getLinkType(link) {
            if (link.type === 'link' && link.data.url) {
                if (
                    link.data.url.startsWith("https://t.me") ||
                    link.data.url.startsWith("https://telegram.me")
                ) {
                    return 'telegram'
                } else if (
                    link.data.url.startsWith("https://wa.me") ||
                    link.data.url.startsWith("https://api.whatsapp.com")
                ) {
                    return 'whatsapp'
                }
            }

            return link.type
        },
    },
    mounted() {
        this.load()
    }
}
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Open+Sans:wght@400;500;700&display=swap');
@import '~vue2-perfect-scrollbar';

.wb-widget {
    all: unset;
    position: fixed;
    right: 30px;
    bottom: 30px;
    width: 380px;
    font-size: 14px;
    font-family: -apple-system, BlinkMacSystemFont, Helvetica Neue, Open Sans, Roboto, "Noto Sans Armenian", "Noto Sans Bengali", "Noto Sans Cherokee", "Noto Sans Devanagari", "Noto Sans Ethiopic", "Noto Sans Georgian", "Noto Sans Hebrew", "Noto Sans Kannada", "Noto Sans Khmer", "Noto Sans Lao", "Noto Sans Osmanya", "Noto Sans Tamil", "Noto Sans Telugu", "Noto Sans Thai", sans-serif;
    user-select: none;
    box-sizing: border-box;
    z-index: 100000000000;

    * {
        box-sizing: border-box;
    }

    &__dialog {
        width: 100%;
        float: left;
        box-shadow: rgb(0 0 0 / 16%) 0 5px 40px;
        border-radius: 0.71em;
        position: relative;
        background: #ffffff;
        z-index: 2;
        max-height: calc(100vh - 125px);
        overflow: hidden;
        margin-bottom: 20px;
    }

    &__dialog-scroll {
        max-height: calc(100vh - 125px);
        float: left;
    }

    &__banner{
        width: 100%;
        float: left;
        img{
            width: 100%;
            float: left;
        }
    }

    &__header{
        width: 100%;
        float: left;
        padding: 1.07em 2em 2.91em 2em;
        background: #F5F5F5;

        &_s{
            padding-bottom: 1.07rem;
        }
    }

    &__content{
        width: 100%;
        float: left;
        padding: 0 0.71em;
    }

    &__links{
        border: 1px solid #E0E0E0;
        margin-top: -1.84em;
        background: #ffffff;
        border-radius: 5px;
        max-height: 319px;
        overflow: hidden;
    }

    &__scroll{
        max-height: 319px;
    }

    &__link{
        text-decoration: none;
        display: flex;
        align-items: center;
        line-height: 52px;
        padding: 0 1.29em;
        border-bottom: 1px solid #F5F5F5;
        cursor: pointer;
        font-weight: 400;
        transition: all .2s;
        color: #000000;

        &:hover{
            text-decoration: none;
            background-color: #FAFAFA;
        }

        div{
            margin-right: 0.5em;
            width: 2.28em;
            height: 2.28em;
        }
    }

    &__title{
        font-weight: 600;
        font-size: 1.75em;
        line-height: 1.34;
        margin: 5px 0;
        position: relative;
    }

    &__close{
        position: absolute;
        right: 0;
        top: 0;
        display: none;
        align-items: center;
        justify-content: flex-end;
        width: 36px;
        cursor: pointer;
    }

    &__description{
        font-weight: 500;
        font-size: 1.04em;
    }

    &__icon{
        width: 100%;
        display: flex;
        justify-content: flex-end;
        margin-top: 20px;
    }

    &__btn{
        background: #2196F3;
        width: 64px;
        height: 64px;
        border-radius: 50%;
        cursor: pointer;
        position: relative;
        margin-left: 15px;

        &_cog{
            background: #9E9E9E;
        }

        & > div{
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
        }
    }

    &__channel{
        padding: 20px;

        &-info{
            width: 100%;
            text-align: center;
        }

        &-qr-code{
            padding: 30px;
            display: flex;
            align-items: center;
            justify-content: center;
            text-align: center;

            div {
                width: 60%;

                img {
                    width: 100%;
                }
            }
        }

        &-btn{
            width: 100%;
            height: 44px;
            background: #2196F3;
            border-radius: 44px;
            display: flex;
            align-items: center;
            justify-content: center;
            line-height: 1;
            color: #ffffff;
            font-size: 1rem;
            cursor: pointer;
            text-decoration: none;
            transition: all .2s;

            svg{
                width: 24px;
                height: 24px;
                margin-right: 5px;
            }

            &:hover{
                background: #1976D2;
                text-decoration: none;
            }

            &_whatsapp{
                background: #01e675;

                &:hover{
                    background: #46ffa4;
                }
            }

            &_telegram{
                background: #32afed;

                &:hover{
                    background: #72cbf7;
                }
            }

            &_viber{
                background: #8074d6;

                &:hover{
                    background: #afa6ec;
                }
            }

            &_facebook{
                background: #0084ff;

                &:hover{
                    background: #04a0ff;
                }
            }

            &_instagram{
                background: #f50257;

                &:hover{
                    background: #f80e60;
                }
            }

            &_vk{
                background: #5181b8;

                &:hover{
                    background: #4a76a8;
                }
            }

            &_icq{
                background: #28ca86;

                &:hover{
                    background: #15de8a;
                }
            }
        }
    }

    &__copyright{
        display: block;
        width: 100%;
        text-align: center;
        font-size: 0.8em;
        color: #000000;
        padding: 0.8em;
        text-decoration: none;
        float: left;

        &:hover{
            text-decoration: none;
        }
    }

    .wb-show-icon-enter-active {
        animation: wb-show-icon-in .1s;
    }
    .wb-show-icon-leave-active {
        animation: wb-show-icon-in .3s reverse;
    }
    @keyframes wb-show-icon-in {
        0% {
            opacity: 0;
        }
        90% {
            opacity: 0;
        }
        100% {
            opacity: 1;
        }
    }

    .wb-close-icon-enter-active {
        animation: wb-close-icon-in .3s;
    }
    .wb-close-icon-leave-active {
        animation: wb-close-icon-in .1s reverse;
    }
    @keyframes wb-close-icon-in {
        0% {
            transform: rotate(90deg);
            opacity: 0;
        }
        100% {
            transform: rotate(0);
            opacity: 1;
        }
    }

    .wb-visible-enter-active {
        animation: wb-visible-in .3s;
    }
    .wb-visible-leave-active {
        animation: wb-visible-in .1s reverse;
    }
    @keyframes wb-visible-in {
        0% {
            bottom: -50px;
            opacity: 0;
        }
        100% {
            bottom: 0;
            opacity: 1;
        }
    }

    @media only screen and (max-width: 600px) {
        right: 0;
        bottom: 0;
        width: 100%;

        &__close{
            display: flex;
        }

        &__dialog{
            margin-bottom: -64px;
            border-radius: 0;
            max-height: 100vh;

            &-scroll{
                max-height: 100vh;
            }
        }

        &__icon{
            position: relative;
            right: 20px;
            bottom: 20px;
        }
    }
}
</style>
